import { computed, type ComputedRef } from 'vue'
import { useStationStore } from '@/pinia-store/useStationStore'
import { useDashboardLensStore } from '@/pinia-store/useDashboardLensStore'
import { useDemandTimelineStore } from '@/pinia-store/useDemandTimelineStore'
import { showUnidentifiedLegend } from '@/modules/company/Dashboard/lenses/legend'
import { timelineHasUnidentified } from '@/modules/company/Dashboard/timeline/timelineModel'

/**
 * A legenda do topo (grupo + "Ver legenda completa") mostra "Ocupado s/ ident." quando a
 * resposta da grade conhece o estado. No modo Timeline a grade não é a fonte do que está
 * na tela: vale também a resposta da timeline (Minor 8 — a entrada sumia nesse modo).
 */
export function useLegendShowsUnidentified(): ComputedRef<boolean> {
  const stationStore = useStationStore()
  const lensStore = useDashboardLensStore()
  const timelineStore = useDemandTimelineStore()
  return computed(
    () =>
      showUnidentifiedLegend(stationStore.listStations) ||
      (lensStore.lens?.period === 'timeline' && timelineHasUnidentified(timelineStore.data))
  )
}
